<template>
  <div v-if="loading">
    <div class="container main has-text-centered">
      <div class="title is-4 has-text-primary">
        Retrieving flight details...
      </div>
      <div>
        <i class="fas fa-gear has-text-primary fa-3x fa-spin"></i>
      </div>
    </div>
  </div>
  <section v-else class="container" :class="!isMeeting ? 'boxWithBorder' : ''">
    <!-- Meeting Info Bar bar -->
    <div v-if="isMeeting" class="box">
      <div v-if="route() != '/meetings/flights-results'">
        <MeetingDatesInfoForUser />
        <hr />
      </div>

      <p class="is-size-5">
        Will you provide your own transportation to and from this meeting?
      </p>
      <!-- <b-button>
        Opt out of flight search steps
      </b-button> -->
      <p class="is-size-6 mb-3">
        If you do not need air travel for this meeting, please click below to
        skip the flight search.
      </p>
      <b-button @click="optOutFlight" type="is-primary">
        No Air Travel Required
      </b-button>
    </div>

    <div v-if="useAtcShopper">
      <div
        class="is-justify-content-center mb-3 has-text-primary has-text-weight-bold"
      >
        Exchanging ticket to
        {{
          $helpers.getAirportLocation($store.state.bookTravel.atc.destination)
        }}
        on
        {{ $helpers.getAirlineName($store.state.bookTravel.atc.airline) }}
      </div>
      <div></div>
      <div>Show original flight segments</div>
      <div class="block my-2">
        <b-radio v-model="radio" name="name" :native-value="true">
          Show
        </b-radio>
        <b-radio v-model="radio" name="name" :native-value="false">
          Hide
        </b-radio>
      </div>
    </div>

    <div v-if="radio" class="columns">
      <div
        class="column is-3"
        v-for="(journey, index) in atcJourneys"
        :key="index"
        style="min-width:300px"
      >
        <AtcJourney :journey="journey" />
      </div>
    </div>

    <SmallItinerarySidebar
      v-if="bookTrip.currentlyBooking && !useAtcShopper"
      :sol="solutionAll"
      :key="
        solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key
      "
      class="bookingDropdown mr-5"
    />

    <!-- Form Title -->
    <div
      v-if="!isMeeting"
      class="is-flex is-justify-content-center is-align-content-center mb-3"
    >
      <b-icon icon="airplane" size="" type="is-primary"></b-icon>

      <h2 v-if="useAtcShopper" class="gant-text is-bold ml-1">
        Search for a new flight:
      </h2>

      <h2 v-else class="gant-text is-bold ml-1">Flights</h2>
    </div>

    <!-- TODO fix -->
    <EditSearchLink
      v-if="showEditSearchLink('flight')"
      :label="toggleSearchLabel('flight')"
      @iconClicked="toggleSearchForm('flight')"
    />

    <div
      class="flightForm"
      :class="bookTrip.currentlyBooking ? 'pt-2' : ''"
      v-if="!this.bookTravel.formsCollapsed.flight"
    >
      <div :class="isMeeting ? 'box' : ''">
        <!-- Action bar -->
        <div class="is-flex is-justify-content-center flexContainer">
          <div class="flexContainerItem">
            <div class="is-flex is-justify-content-center">
              <TripTypeSelectorDropdown
                v-if="!pathMixin_isMeeting"
                v-model="tripVal"
                @switch="toggle1way"
                class="flexContainerItem"
                :disabled="useAtcShopper"
              />
              <CabinClassSelectorDropdown
                @input="updateCabinClass"
                :selectedValue="cabinClass"
                :cabinOptions="cabinOptions"
                class="ml-1 flexContainerItem"
              />
            </div>
          </div>
          <UserAirNotifications
            class="ml-1 flexContainerItem is-hidden-touch"
            custom-style="font-size: 12px;"
          />
        </div>
        <!-- END OF Action bar -->

        <b-message type="is-warning" v-if="isMeeting" class="mt-3">
          <span v-html="labelForMeeting('depart')"></span>
          <br />
          <span v-html="labelForMeeting('return')"></span>
        </b-message>

        <!--  One-Way & Round Trip -->
        <div
          v-show="tripVal === TRIP_ONE_WAY || tripVal === TRIP_ROUNDTRIP"
          class="mt-3"
        >
          <div class="is-flex is-justify-content-space-between flexContainer">
            <div class="is-flex-grow-1 flexContainerItem">
              <LocationSearch
                data-test="depart_airport"
                icon="airplane-takeoff"
                :key="locationKey"
                :value="loc1"
                @locUpdate="setValue1"
                ref="loc1"
                :offerHomeAirport="true"
                :autofocus="true"
                :placeholder="'From (e.g. LAX, BOS)'"
                data-test-attr="from-destination"
                :disabled="!showGeo"
                :clearable="showGeo"
              />
            </div>
            <div
              class="is-flex-grow-0 flexContainerItem swapFlightsContainer"
              v-if="!pathMixin_isMeeting"
            >
              <a class="image is-48x48 swapFlightsButton is-hidden-mobile">
                <img
                  v-if="showGeo"
                  :class="swapButton"
                  class="fade"
                  @mousedown="switchLoc"
                  src="/images/gantFlipButton.png"
                  alt="Swap Airports"
                />
                <img
                  v-else
                  :class="swapButton"
                  style="opacity: 0.1;"
                  src="/images/gantFlipButton.png"
                  alt="Swap Airports (disabled)"
                />
              </a>
            </div>
            <div
              class="is-flex-grow-1 ml-1 flexContainerItem departLocationSearch"
              v-if="pathMixin_isMeeting"
            >
              <LocationSearchMeetings
                data-test="arrive_airport_meetings"
                icon="airplane-landing"
                @locUpdate="setMeetingsDestination"
                :options="meetingAirports"
                :preferred="prefAirport"
              />
            </div>
            <div
              class="is-flex-grow-1 flexContainerItem departLocationSearch"
              v-else
            >
              <LocationSearch
                data-test="arrive_airport"
                icon="airplane-landing"
                :key="locationKey + 1"
                :value="loc2"
                @locUpdate="setValue2"
                ref="loc2"
                :offerHomeAirport="true"
                :placeholder="'To (e.g. LAX, BOS)'"
                data-test-attr="to-destination"
                :disabled="!showGeo"
                :clearable="showGeo"
              />
            </div>

            <div class="is-flex-grow-2 flexContainerItem">
              <div class="is-flex flexContainer flexContainerRow">
                <div
                  v-if="!disableStartDate"
                  class="is-flex-grow-1 mr-1 flexContainerItem"
                >
                  <FlightDateTimeSelector
                    data-test="departDate"
                    ref="departDate"
                    :dateIndex="0"
                    v-model="startDate"
                    :placeholder="'Depart'"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    :focusedDate="focusedDate"
                    @setDate="toggleReturn"
                    @showAdvanced="showAdvanced"
                    @meetingInput="setMeetingsDepartDate"
                    @setDateRange="setDateRange"
                    type="departure"
                  />
                </div>
                <div v-else class="is-flex-grow-1 mr-1 flexContainerItem">
                  <input
                    :value="formatDate(startDate.date)"
                    style="border: 1px solid #dbdbdb; padding: 0.5em; width: 100%;"
                    type="text"
                    autocomplete="off"
                    placeholder="Depart"
                    readonly="readonly"
                    class="input"
                    disabled
                  />
                </div>
                <div
                  class="is-flex-grow-1 flexContainerItem"
                  v-if="tripVal === TRIP_ROUNDTRIP"
                >
                  <div v-if="!disableEndDate">
                    <FlightDateTimeSelector
                      data-test="returnDate"
                      ref="returnDate"
                      :dateIndex="1"
                      v-model="endDate"
                      :placeholder="'Return'"
                      :minDate="minDate"
                      :maxDate="maxDate"
                      :focusedDate="focusedDate"
                      @showAdvanced="showAdvanced"
                      @meetingInput="setMeetingsReturnDate"
                      @setDateRange="setDateRange"
                      type="return"
                    />
                  </div>
                  <div v-else class="is-flex-grow-1 mr-1 flexContainerItem">
                    <input
                      :value="formatDate(endDate.date)"
                      style="border: 1px solid #dbdbdb; padding: 0.5em; width: 100%;"
                      type="text"
                      autocomplete="off"
                      placeholder="Depart"
                      readonly="readonly"
                      class="input"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="is-flex-grow-1 flexContainerItem searchButton is-hidden-mobile is-hidden-touch"
            >
              <b-button
                data-test="desktop_submit_button"
                @click="checkInputs"
                class="button is-primary ubuntu"
                expanded
              >
                Search Flights
              </b-button>
            </div>
          </div>

          <b-collapse
            :open="advancedOptionOpen"
            @open="advancedOptionOpen = true"
            @close="advancedOptionOpen = false"
            aria-id="contentIdForA11y1"
            data-test="advance-search-opener"
          >
            <AdvancedSearchOptionsLink
              data-test="advanced-search-options-link"
              slot="trigger"
            />

            <div data-test="advance-search-container" class="notification px-3">
              <button
                class="delete"
                @click="advancedOptionOpen = false"
              ></button>
              <div class="content">
                <h3>Time Preference</h3>
                <div class="columns">
                  <b-field class="column">
                    <b-radio-button
                      size="is-small"
                      type="is-primary is-light is-outlined"
                      v-for="option in times"
                      v-model="startDate.advanced.tod"
                      :key="option.format"
                      :name="option.format"
                      :native-value="option.format"
                      :disabled="showAdvancedSearchD == 0"
                      :data-test="'start-choice-' + option.format.toLowerCase()"
                    >
                      {{ option.format }}
                    </b-radio-button>
                  </b-field>

                  <b-field class="column" v-if="tripVal === TRIP_ROUNDTRIP">
                    <b-radio-button
                      size="is-small"
                      type="is-primary is-light is-outlined"
                      v-for="option in times"
                      v-model="endDate.advanced.tod"
                      :key="option.format"
                      :native-value="option.format"
                      :disabled="showAdvancedSearchR == 0"
                      :data-test="
                        'depart-choice-' + option.format.toLowerCase()
                      "
                    >
                      <span style=""> {{ option.format }} </span>
                    </b-radio-button>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div
                    data-test="outbound-container"
                    class="content"
                    v-show="
                      !disableStartDate && startDate.advanced.tod == 'Custom'
                    "
                  >
                    <h4>
                      Outbound Flight
                    </h4>
                    <div
                      v-if="startDate.advanced.tod == 'Custom'"
                      class="columns"
                    >
                      <div
                        class="column"
                        data-test="outbound-timepicker-container"
                      >
                        <b-field>
                          <b-timepicker
                            data-test="outbound-timepicker"
                            ref="startClock"
                            rounded
                            icon="clock"
                            is-small
                            :incrementMinutes="minutesGranularity"
                            :hour-format="hourFormat"
                            v-model="startTime"
                          >
                          </b-timepicker>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field>
                          <b-radio-button
                            data-test="outbound-takeoff"
                            v-model="outboundTakeoff"
                            native-value="takeoff"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-takeoff"></b-icon>
                            Takeoff
                          </b-radio-button>
                          <b-radio-button
                            data-test="outbound-arrival"
                            v-model="outboundTakeoff"
                            native-value="arrival"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-landing"></b-icon>
                            Arrival
                          </b-radio-button>
                        </b-field>
                      </div>
                    </div>

                    <b-field
                      v-if="startDate.advanced.tod == 'Custom'"
                      :label="plusorMinusHours1"
                    >
                      <b-numberinput
                        data-test="outbound-plusminus"
                        v-model="startDate.advanced.hours"
                        min="1"
                        max="10"
                        :step="1"
                        controls-position="compact"
                      >
                      </b-numberinput>
                    </b-field>
                  </div>
                </div>
                <div class="column">
                  <div
                    class="content"
                    data-test="return-container"
                    v-show="
                      !disableEndDate &&
                        tripVal == TRIP_ROUNDTRIP &&
                        endDate.advanced.tod == 'Custom'
                    "
                  >
                    <h4>Return Flight</h4>
                    <div
                      data-test="return-timepicker-container"
                      class="columns"
                    >
                      <div class="column">
                        <b-field>
                          <b-timepicker
                            data-test="return-timepicker"
                            ref="endClock"
                            rounded
                            icon="clock"
                            is-small
                            :incrementMinutes="minutesGranularity"
                            :hour-format="hourFormat"
                            v-model="endTime"
                          >
                          </b-timepicker>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field>
                          <b-radio-button
                            data-test="return-takeoff"
                            v-model="returnTakeoff"
                            native-value="takeoff"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-takeoff"></b-icon>
                            Takeoff
                          </b-radio-button>
                          <b-radio-button
                            data-test="return-arrival"
                            v-model="returnTakeoff"
                            native-value="arrival"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-landing"></b-icon>
                            Arrival
                          </b-radio-button>
                        </b-field>
                      </div>
                    </div>

                    <b-field :label="plusorMinusHours2">
                      <b-numberinput
                        data-test="return-plusminus"
                        v-model="endDate.advanced.hours"
                        min="1"
                        max="10"
                        :step="1"
                        controls-position="compact"
                      >
                      </b-numberinput>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>

        <!-- Multi-City -->
        <div v-show="tripVal === TRIP_MULTI_CITY" class="mt-3">
          <MultiCityRow
            v-for="(child, index) in multiCityRows"
            :index="index"
            v-model="multiCityRows[index]"
            :notAlone="multiCityRows.length > 1"
            :key="index"
            ref="multiRows"
            :minDate="defaultDateRow(index)"
            :focusedDate="defaultDateRow(index)"
            @update="updateRow(index, $event)"
            @nextLeg="focusNextLeg"
            @remove="removeRow"
            class="pr-5"
            data-test="multiple-city-flight-row"
          />

          <div class="columns pr-5">
            <div class="column is-one-third">
              <a
                class="is-info is-size-7 has-text-grey-light"
                v-if="multiCityRows.length < 3"
                @click="addRow"
                data-test="another-flight"
              >
                + Add another Flight
              </a>
            </div>
            <div class="column is-hidden-mobile is-hidden-touch">
              <b-button
                data-test="desktop_submit_button_multiple_city"
                @click="checkInputs"
                class="button is-primary ubuntu is-pulled-right"
              >
                Search Flights
              </b-button>
            </div>
          </div>
        </div>

        <div
          class="is-flex-grow-1 flexContainerItem searchButton is-hidden-desktop"
        >
          <b-button
            data-test="mobile_submit_button"
            @click="checkInputs"
            class="button is-primary ubuntu"
            expanded
          >
            Search Flights
          </b-button>
        </div>
      </div>
    </div>

    <FlightResults
      v-if="showFlightResults"
      :cacheKey="cacheKey"
      :formData="formData"
    />
  </section>
</template>

<script>
import moment from "moment"
import AtcJourney from "@/components/Trip/AtcJourney.vue"
import AirCancelled from "@/components/Trip/AirCancelled.vue"
import MultiCityRow from "./MultiCityRow.vue"
import FlightDateTimeSelector from "./FlightDateTimeSelector.vue"
import LocationSearch from "../../EDLocation/EDLocationSearch.vue"
import TripTypeSelectorDropdown from "./TripTypeSelectorDropdown"
import CabinClassSelectorDropdown from "./CabinClassSelectorDropdown"
//import GuestSelectorDropdown from "./GuestSelectorDropdown";
import AdvancedSearchOptionsLink from "../../UI/AdvancedSearchOptionsLink"
import UserAirNotifications from "../../User/UserAirNotifications"
import LocationSearchMeetings from "../../EDLocation/EDLocationSearchMeetings"
import TravellerModal from "../../Traveller/TravellerModal"
import bookingMixin from "@/mixins/bookingMixin"
import meetingsMixin from "@/mixins/meetingsMixin"
import EditSearchLink from "../EditSearchLink"
import { mapState } from "vuex"
import SmallItinerarySidebar from "../../Itinerary/SmallItinerarySidebar"
import MeetingDatesInfoForUser from "../../Meetings/MeetingDatesInfoForUser"
import FlightResults from "./FlightResults"
//import RecentSearches from "./RecentSearches";
import LocationAutocomplete from "../../../modules/locationAutocomplete"
import Location from "@/models/Location" //Create a fake GoogleAutocomplete type airport location object
import { fetchBookingBotData } from "../../../modules/fetchBookingBotData.js"

export default {
  name: "FlightForm",
  mixins: [bookingMixin, meetingsMixin],
  components: {
    AdvancedSearchOptionsLink,
    MultiCityRow,
    FlightDateTimeSelector,
    LocationSearch,
    TripTypeSelectorDropdown,
    CabinClassSelectorDropdown,
    UserAirNotifications,
    LocationSearchMeetings,
    EditSearchLink,
    SmallItinerarySidebar,
    MeetingDatesInfoForUser,
    FlightResults,
    AtcJourney,
    //RecentSearches
  },
  data() {
    let today = new Date()
    return {
      loading: false,
      radio: false,
      today: today,
      minutesGranularity: 15,
      hourFormat: "12",
      advancedOptionOpen: false,
      locationKey: 0,
      showFlightResults: false,
      meetingsDepartDate: null,
      meetingsReturnDate: null,
      meetingsDestination: null,
      showAdvancedSearchD: true,
      showAdvancedSearchR: true,
      showTimeSelectorDepart: true,
      showTimeSelectorReturn: true,
      cacheKey: null,
      formData: {},
      //FORM DATA
      tripVal: 1,
      cabinClass: null,
      loc1: {
        code: "",
        city: "",
        state: "",
        country: "",
        gantRanking: 0,
        utcOffsetHours: 0,
        cityCode: "",
        countryName: "",
        classification: 0,
        airportName: "",
        detailedName: "",
        subType: "AIRPORT",
        geocode: null,
        airportAdded: false,
        altered: false,
      },
      loc2: {
        code: "",
        city: "",
        state: "",
        country: "",
        gantRanking: 0,
        utcOffsetHours: 0,
        cityCode: "",
        countryName: "",
        classification: 0,
        airportName: "",
        detailedName: "",
        subType: "AIRPORT",
        geocode: null,
        airportAdded: false,
        altered: false,
      },
      startDate: {
        date: null,
        advanced: {
          time: null,
          isDeparture: true,
          tod: "Anytime",
          hours: 2,
        },
      },
      endDate: {
        date: null,
        advanced: {
          time: null,
          isDeparture: true,
          tod: "Anytime",
          hours: 2,
        },
      },
      multiCityRows: [],
      //END FORM DATA
    }
  },
  props: {
    botSessionId: {
      type: String,
      default: null,
    },
    selectedFlight: {
      type: String,
      default: null,
    },
  },
  watch: {
    $route(to, from) {
      const key = this.$route.query.key
      if (key) {
        console.log("key: " + key)
        this.setCacheKey(key)
        this.loadSavedSearch(this.cacheKey)
      }
    },
    atcJourneys: {
      handler: function(val, oldVal) {
        const firstJourney = this.atcJourneys[0]

        if (firstJourney.requestCode == "K") {
          this.loadAtcGeo()
          this.startDate.date = moment(
            firstJourney.segments[0].startDate.date
          ).toDate()
          //this.disableStartDate = true;
          //this.disableGeo = true;
        }

        const lastJourney = this.atcJourneys[this.atcJourneys.length - 1]

        if (lastJourney.requestCode == "K") {
          this.loadAtcGeo()
          this.endDate.date = moment(
            lastJourney.segments[0].startDate.date
          ).toDate()
          //this.disableEndDate = true;
          //this.disableGeo = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    useAtcShopper() {
      return this.$store.state.bookTravel.atc?.useAtcShopper
    },
    atcJourneys() {
      return this.$store.state.bookTravel.atc?.journeys || []
    },
    firstJourney() {
      return this.atcJourneys[0]
    },
    lastJourney() {
      return this.atcJourneys[this.atcJourneys.length - 1]
    },
    disableStartDate() {
      return this.firstJourney?.requestCode == "K"
    },
    disableEndDate() {
      return this.lastJourney?.requestCode == "K"
    },
    ticketSegments() {
      return this.$store.state.bookTravel.atc?.segments || []
    },
    swapButton() {
      return this.$app.isMobileVersion()
        ? "mobile-swapButton"
        : "desktop-swapButton"
    },
    plusorMinusHours1() {
      return "+/-" + this.startDate.advanced.hours + " hours"
    },
    plusorMinusHours2() {
      return "+/-" + this.endDate.advanced.hours + " hours"
    },
    isPersonalTrip() {
      return (
        this.$store.getters["travellersAndTrips/getTravellers"].tripType ==
        "personal"
      )
    },
    showGeo() {
      let geoTicketRule = this.$store.state.bookTravel.atc?.ticketRules?.geo
      let useAtcShopper = this.$store.state.bookTravel.atc?.useAtcShopper

      if (
        this.firstJourney?.requestCode == "K" ||
        this.lastJourney?.requestCode == "K"
      ) {
        return false
      } else if (useAtcShopper && geoTicketRule != "Y") {
        return false
      }

      return true
    },
    focusedDate() {
      if (this.startDate.date) {
        return this.startDate.date
      } else {
        return new Date()
      }
    },
    minDate() {
      if (this.pathMixin_isMeeting) {
        return this.minMeetingDepartDate
      } else {
        return new Date() //this.$date.getFirstTravelDate();
      }
    },
    maxDate() {
      if (this.pathMixin_isMeeting) {
        return this.maxMeetingReturnDate
      } else {
        return this.$date.getLastTravelDate().toDate()
      }
    },
    outboundTakeoff: {
      get() {
        return this.startDate.advanced.isDeparture ? "takeoff" : "arrival"
      },
      set(value) {
        if (value == "takeoff") {
          this.startDate.advanced.isDeparture = true
        } else {
          this.startDate.advanced.isDeparture = false
        }
      },
    },
    returnTakeoff: {
      get() {
        return this.endDate.advanced.isDeparture ? "takeoff" : "arrival"
      },
      set(value) {
        if (value == "takeoff") {
          this.endDate.advanced.isDeparture = true
        } else {
          this.endDate.advanced.isDeparture = false
        }
      },
    },
    cabinOptions() {
      if (this.isPersonalTrip) return null

      let cabinOptions = null

      // If we are in meeting mode then use the cabin options from the
      // travel policy associated to the traveler for this meeting.
      // Otherwise use the options for the traveler's regular travel policy
      if (this.pathMixin_isMeeting) {
        if (
          this.$store.state.meetings.meetingInfo.travelPolicy &&
          this.$store.state.meetings.meetingInfo.travelPolicy.cabinOptions
        ) {
          cabinOptions = this.$store.state.meetings.meetingInfo.travelPolicy
            .cabinOptions
        }
      } else if (this.$globals.profile.travelPolicy) {
        cabinOptions = this.$globals.profile.travelPolicy.cabinOptions
      }

      return cabinOptions
    },
    errorMessages() {
      var messages = []
      var yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      if (
        this.tripVal === this.TRIP_ONE_WAY ||
        this.tripVal === this.TRIP_ROUNDTRIP
      ) {
        if (!Object.hasOwn(this.loc1, "code")) {
          messages.push('Please enter a valid "from" airport')
        }

        if (!Object.hasOwn(this.loc2, "code")) {
          messages.push('Please enter a valid "to" airport')
        }

        if (!this.startDate.date) {
          messages.push("Please select a valid departure date")
        }

        if (this.startDate.date < yesterday) {
          messages.push("Please select a valid departure date")
        }

        if (
          this.endDate.date < yesterday &&
          this.tripVal === this.TRIP_ROUNDTRIP
        ) {
          messages.push("Please select a valid return date")
        }

        if (
          this.tripVal === this.TRIP_ROUNDTRIP &&
          this.startDate.date > this.endDate.date
        ) {
          messages.push("Return date is after departure date")
        }

        if(this.startDate.advanced.tod == "Custom" && this.startDate.advanced.time == null) {
          messages.push("Please select a valid departure time")
        }
        
        if(this.endDate.advanced.tod == "Custom" && this.endDate.advanced.time == null) {
          messages.push("Please select a valid departure time")
        }

      } else {
        var previousDate
        if (this.multiCityRows[0].depDate.date < yesterday) {
          messages.push("Please select a future departure date for flight 1")
        }
        for (var child = 0; child < this.multiCityRows.length; child++) {
          if (!this.multiCityRows[child].fromLoc.code) {
            messages.push('Invalid "from" airport in flight ' + (child + 1))
          }
          if (!this.multiCityRows[child].toLoc.code) {
            messages.push('Invalid "to" airport in flight ' + (child + 1))
          }
          if (
            !(child === 0) &&
            this.multiCityRows[child].depDate.date < previousDate
          ) {
            messages.push(
              "Flight " + (child + 1) + " date must be after Flight " + child
            )
          }
          previousDate = this.multiCityRows[child].depDate.date
        }
      }
      return messages
    },
    startTime: {
      get() {
        const t = this.startDate?.advanced?.time;
        return typeof t === 'string' ? new Date(t) : t;
      },
      set(value) {
        this.startDate.advanced.time = value;
      }
    },
    endTime: {
      get() {
        const t = this.endDate?.advanced?.time;
        return typeof t === 'string' ? new Date(t) : t;
      },
      set(value) {
        this.endDate.advanced.time = value;
      }
    }
  },
  methods: {
    autofillFormValues(searchDetails) {
      this.tripVal = searchDetails.tripVal
      this.loadGeo(searchDetails.departAirport, searchDetails.arriveAirport)
      this.startDate.date = new moment(searchDetails.startDate).toDate()
      this.endDate.date = new moment(searchDetails.endDate).toDate()
      this.multiCityRows = searchDetails.multiCityRows.map((item) => ({
        fromLoc: { code: item.departAirport },
        toLoc: { code: item.arriveAirport },
        depDate: { date: new Date(item.startDate) },
      }))
    },
    formatDate(date) {
      return moment(date).format("MM/DD/YYYY")
    },
    // TODO check all methods that have dates or use moment() and see if those can be standardized
    checkInputs() {
      if (this.errorMessages.length > 0) {
        this.launchInputErrorDialog(this.errorMessages)
      } else {
        this.presearch()
      }
    },
    presearch() {
      if (this.$store.state.travellersAndTrips.travellers.set) {
        this.search()
      } else {
        this.cardModal()
      }
    },
    setCacheKey(value) {
      this.cacheKey = value
    },
    search() {
      // TODO test for possible removal ?
      if (this.pathMixin_isMeeting) {
        this.$store.commit(
          "meetings/ALTER_MEETING_AIRPORT_SELECTED",
          this.meetingsDestination
        )
      }
      //
      this.showFlightResults = true
      this.advancedOptionOpen = false

      //reset cacheKey to null to force a new search
      this.setCacheKey(null)

      this.logSearchEvent()

      this.formData = {
        tripVal: this.tripVal,
        cabinClass: this.cabinClass,
        loc1: this.loc1,
        loc2: this.loc2,
        minDate: this.minDate,
        startDate: this.startDate,
        endDate: this.endDate,
        multiCity: this.multiCityRows,
      }
    },
    logSearchEvent() {
      // Event itinerary_type
      // this.TRIP_ONE_WAY = 0
      // this.TRIP_ROUNDTRIP = 1
      // this.TRIP_MULTI_CITY = 2
      let itineraryType = null
      
      if (this.tripVal === this.TRIP_ONE_WAY) {
        itineraryType = 'one_way'
      } else if (this.tripVal === this.TRIP_ROUNDTRIP) {
        itineraryType = 'round_trip'
      } else if (this.tripVal === this.TRIP_MULTI_CITY) {
        itineraryType = 'multi_city'
      }

      // Log the event
      let eventData = {
        event_type: 'Search Submitted',
        event_properties: {
          item_type: 'air',
          itinerary_type: itineraryType,
          // days_until_travel:
        }
      }
        
      this.$app.logEvent(eventData);
    },
    getSegmentByTattoo(tattoo) {
      return this.$store.state.bookTravel.atc.segments.find(
        (segment) => segment.tattoo == tattoo
      )
    },
    loadAtcData() {
      this.loadAtcGeo()
      this.loadAtcDates()
      this.tripVal = this.$store.state.bookTravel.atc.journeys.length - 1 // 1 = one way, 2 = round trip, 3 = multi city
    },
    loadAtcDates() {
      let atcDetails = this.$store.state.bookTravel.atc
      this.startDate.date = new moment(atcDetails.startDate).toDate()
      this.endDate.date = new moment(atcDetails.endDate).toDate()
    },
    loadGeo(origin, destination) {
      this.loc1 = new Location(origin)
      this.loc2 = new Location(destination)
    },
    loadAtcGeo() {
      let atcDetails = this.$store.state.bookTravel.atc
      this.loc1 = new Location(atcDetails.origin)
      this.loc2 = new Location(atcDetails.destination)
    },
    loadSavedSearch(cacheKey) {
      console.log("loading saved search for key: " + cacheKey)
      let recentSearches = this.$store.state.bookTravel.recentSearches
      let savedSearch = recentSearches.find((search) => search.key === cacheKey)

      if (savedSearch) {
        //clone the saved search data
        let formData = JSON.parse(JSON.stringify(savedSearch.formData))

        this.tripVal = formData.tripVal
        this.cabinClass = formData.cabinClass
        this.loc1 = formData.loc1
        this.loc2 = formData.loc2
        this.startDate = formData.startDate
        this.startDate.date = new Date(formData.startDate.date)
        this.endDate = formData.endDate
        this.endDate.date = new Date(formData.endDate.date)
        this.multiCity = formData.multiCityRows

        this.formData = formData
        this.showFlightResults = true
      }
    },
    showAdvanced() {
      this.advancedOptionOpen = true
    },
    switchLoc() {
      //this.$store.dispatch("bookTravel/switchLoc");
      let temp = this.loc2
      this.loc2 = this.loc1
      this.loc1 = temp
      this.locationKey += 1
    },
    setDateRange(range) {
      this.startDate.date = range[0]
      this.endDate.date = range[1]
    },
    setValue1(value) {
      if (this.$refs.loc2 && value) {
        this.$refs.loc2.setUp()
      }
      this.loc1 = value
    },
    setValue2(value) {
      this.loc2 = value
      //toggle the depart DatePicker
      this.toggleDepart()
    },
    updateCabinClass(value) {
      this.cabinClass = value
    },
    toggle1way(value) {
      this.tripVal = value
    },
    setTravellers() {
      let travellers = {
        tripType: "business",
        bookFor: "user",
        others: [],
        set: true,
        business: true,
        self: true,
      }
      this.$store.commit("travellersAndTrips/EDIT_TRAVELLERS", travellers)
    },
    cardModal(closable = true) {
      var details = {
        parent: this,
        component: TravellerModal,
        props: {
          profile: this.$globals.profile,
          closable: closable,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
      }
      this.$buefy.modal.open(details)
    },
    route() {
      return this.$route.path
    },
    // for Meetings
    setMeetingsDepartDate(val) {
      this.meetingsDepartDate = val
      this.validateMeetingDates(val, "depart")
    },
    setMeetingsReturnDate(val) {
      this.meetingsReturnDate = val
      this.validateMeetingDates(val, "return")
    },
    labelForMeeting(type) {
      let label = ""

      if (type == "depart") {
        //label += '<strong>Departure: </strong> ';
        if (this.meetingInfo.meeting.latestArrival.time !== null) {
          label += `<span class="is-size-7">ARRIVE by
                        <b>${this.$date.convertTime(
                          this.meetingInfo.meeting.latestArrival.time
                        )}</b>
                        on ${moment(
                          this.meetingInfo.meeting.latestArrival.date
                        ).format("ddd, MMM D")}
                      </span>`
        }
      }

      if (type == "return") {
        // label += '<strong>Return: </strong> ';
        if (this.meetingInfo.meeting.earliestDeparture.time !== null) {
          label += `<span class="is-size-7">DEPART no earlier than
                      <b>${this.$date.convertTime(
                        this.meetingInfo.meeting.earliestDeparture.time
                      )}</b>
                        on ${moment(
                          this.meetingInfo.meeting.earliestDeparture.date
                        ).format("ddd, MMM D")}
                    </span>`
        }
      }

      return label
    },
    validateMeetingDates(date, type) {
      // console.log(`validateMeetingDates() ${JSON.stringify(date)} - ${type}`);
      // check date to see if we should how/hide Time Selector and Adv SO
      // check if the date is restricted by Meeting Admin
      if (type === "depart") {
        let dDate = moment(this.meetingsDepartDate.date).format("YYYY-MM-DD")
        if (dDate == this.meetingInfo.meeting.latestArrival.date) {
          this.showTimeSelectorDepart = false
          this.showAdvancedSearchD = false
        } else {
          this.showTimeSelectorDepart = true
          this.showAdvancedSearchD = true
        }
      }

      if (type === "return") {
        let rDate = moment(this.meetingsReturnDate.date).format("YYYY-MM-DD")
        if (rDate == this.meetingInfo.meeting.earliestDeparture.date) {
          this.showTimeSelectorReturn = false
          this.showAdvancedSearchR = false
        } else {
          this.showTimeSelectorReturn = true
          this.showAdvancedSearchR = true
        }
      }
    },

    // for multi-city
    focusNextLeg(val) {
      /*
      var index = val[0];
      var info = val[1];
      if (this.multiCityRows.length > index + 1) {
        var ref = this.$refs[`multi${this.multiCityRows[index + 1].id}`];
        ref[0].toggleActive(info);
      }
      */
    },
    //autofill the depart date
    toggleDepart() {
      if (this.startDate.date == null) {
        //pre-set depart date value
        this.startDate.date = new Date()
      }

      //this.$refs.departDate.toggle();
    },
    //toggle the returnDate datePicker dropdown open
    toggleReturn(value) {
      if (this.tripVal === this.TRIP_ROUNDTRIP) {
        if (this.endDate.date == null) {
          //pre-set return date value
          this.endDate.date = value
        }
        this.$refs.returnDate.toggle()
      }
    },

    defaultDateRow(index) {
      if (index > 0) {
        let minDay = new Date(this.multiCityRows[index - 1].depDate.date)
        //nextDay.setDate(nextDay.getDate() + 1);
        return minDay
      } else {
        return this.today
      }
    },
    //add a multiCity row
    addRow() {
      let row = {
        fromLoc: "",
        toLoc: "",
        depDate: {
          date: null,
          advanced: {
            time: null,
            tod: "Anytime",
          },
        },
      }
      this.multiCityRows.push(row)
    },
    //delete a multiCity row
    removeRow(index) {
      this.multiCityRows.splice(index, 1)
      //this.$store.dispatch("bookTravel/removeMulti", index);
    },
    //update a multiCity row
    updateRow(index, newChild) {
      //this.$store.dispatch("bookTravel/updateMulti", [index, newChild]);
      this.$set(this.multiCityRows, index, newChild)
    },
    setDefaultFormValues() {
      this.loc1 = { name: "", locType: "" }
      this.loc2 = { name: "", locType: "" }
      this.startDate = {
        date: null,
        advanced: {
          time: null,
          isDeparture: true,
          tod: "Anytime",
          hours: 2,
        },
      }
      this.endDate = {
        date: null,
        advanced: {
          time: null,
          isDeparture: true,
          tod: "Anytime",
          hours: 2,
        },
      }
    },
    missingDataWarning() {
      this.$buefy.dialog.alert({
        title: 'Missing Data',
        message: "We were missing some details required to complete your flight search. Please press continue in order to proceed to fill in all required fields.",
        type: "is-danger",
        hasIcon: true,
        iconPack: "fas",
        icon: "exclamation-triangle",
        confirmText: "Continue",
        ariaRole: "alertdialog",
      })
    },
  },
  created() {

    this.TRIP_ONE_WAY = 0
    this.TRIP_ROUNDTRIP = 1
    this.TRIP_MULTI_CITY = 2

    // Handle any fetch errors
    if (this.$route.params.fetchError) {
      this.error = this.$route.params.fetchError
    }

    // Set this.cabinClass as the first value from cabinOptions
    if (this.cabinOptions) {
      this.cabinClass = this.cabinOptions[0]
    }
  },

  async mounted() {

    // Log the event
    this.$app.logEvent({
      event_type: 'Search Started',
      event_properties: {
        item_type: 'air'
      }
    });

    //intialize two multi-city rows
    this.addRow()
    this.addRow()

    // TODO Test meeting
    if (this.pathMixin_isMeeting) {
      this.setTravellers()
    }

    this.$nextTick(async function() {
      if (this.$store.state.bookTravel.atc?.useAtcShopper) {
        this.loadAtcData()
      }

      if (!this.pathMixin_isMeeting && this.botSessionId) {
        try {
          this.loading = true
          const result = await fetchBookingBotData({
            tokenApiUrl: process.env.VUE_APP_BOOKINGBOT_TOKEN_URL,
            apiBaseUrl: process.env.VUE_APP_BOOKINGBOT_API_BASE_URL,
            clientId: process.env.VUE_APP_BOOKINGBOT_CLIENT_ID,
            clientSecret: process.env.VUE_APP_BOOKINGBOT_CLIENT_SECRET,
            scope: process.env.VUE_APP_BOOKINGBOT_CLIENT_SCOPE,
            sessionId: this.botSessionId,
          })

          const body = JSON.parse(result.body)
          const data = body.data

          console.log("data", data)

          const params = {
            tripVal:
              data.extracted_data.flight_type === "one_way"
                ? this.TRIP_ONE_WAY
                : this.TRIP_ROUNDTRIP,
            cabinClass: data.extracted_data.cabin_class,
            departAirport: data.extracted_data["Origin Location"],
            arriveAirport: data.extracted_data["Destination Location"],
            startDate: data.extracted_data["Departure Date"],
            endDate: data.extracted_data["Return Date"],
            multiCityRows: [],
            recommendedItems: data.recommended_flights,
          }

          console.log("payload", params)

          this.autofillFormValues(params)

          this.$store.commit(
            "flight/SET_RECOMMENDED_ITEMS",
            data.recommended_flights
          )

          this.$store.commit("flight/SET_SELECTED_FLIGHT", this.selectedFlight)

          //this.checkInputs()
          if (this.errorMessages.length > 0) {
            this.missingDataWarning()
          } else {
            this.presearch()
          }
        } catch (err) {
          this.error = err.message
        } finally {
          this.loading = false
        }
      }
    })

    const key = this.$route.query.key
    if (key) {
      this.setCacheKey(key)
      this.loadSavedSearch(this.cacheKey)
    }
  },
}
</script>

<style lang="scss" scoped>
.fade {
  opacity: 0.3;
  transition: opacity 0.05s ease-in-out;
  -moz-transition: opacity 0.05s ease-in-out;
  -webkit-transition: opacity 0.05s ease-in-out;
}
.fade:hover {
  opacity: 0.7;
}
</style>
